import { useQuery } from "@tanstack/react-query";
import { getHotelMealPlansForSelect } from "../../api/apiHotelMealPlans";
import i18next from "i18next";

const useGetHotelMealPlansForSelect = () => {
    const { data, error, isLoading } = useQuery({
        queryKey: ["HotelMealPlansForSelect", i18next.language],
        queryFn: getHotelMealPlansForSelect,
        staleTime: 1000 * 60 * 30,
    });

    return {
        options: data?.data || [],
        error,
        isLoading,
    };
};

export default useGetHotelMealPlansForSelect;
